@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Reference Files"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column title="" [width]="70">
    <ng-template let-referenceFile kendoGridCellTemplate [unityTyped]="T">
      <unity-button-download-shared
        buttonText=""
        [gridIconOnly]="true"
        [disabled]="$activeDownloadIdSet().has(referenceFile.id)"
        (clickEvent)="downloadFile(referenceFile)" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.name" [link]="['/agreement', $agreementId(), 'reference-file', item.id]" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
